import React from "react";

const Donate = () => {
    return (
        <div className="min-h-screen flex items-start justify-center bg-customFulBlue pt-10">
            <div className="bg-white p-6 rounded-lg shadow-lg">
                <h2 className="text-2xl font-bold mb-4">Support Us</h2>
                <p className="mb-4">
                    If you enjoy using this app, consider supporting us with a coffee!
                </p>
                <a
                    href="https://www.buymeacoffee.com/yourname"
                    target="_blank"
                    rel="noopener noreferrer"
                >
                    <img
                        src="https://cdn.buymeacoffee.com/buttons/v2/default-yellow.png"
                        alt="Buy Me a Coffee"
                        style={{ height: "50px", width: "auto" }}
                    />
                </a>
            </div>
        </div>
    );
};

export default Donate;
